// extracted by mini-css-extract-plugin
export default {"loginContainer":"Login_loginContainer__zwDJG","imageSection":"Login_imageSection__UhC2g","formSection":"Login_formSection__imXkG"};